<template>
  <!-- 详情模块 -->
  <div class="form-wrapper">
    <div class="ft-box">
      <div class="ajFlex">
        <div class="ft-title aFlex">
          <Icon class="ft-title-mark" type="md-bookmark" />
          <span>预警项</span>
        </div>
        <Button type="primary" ghost @click="ruleShow = true">规则说明</Button>
      </div>
      <Tabs :value="activeTabs" type="card" @on-click="tabsClikc">
        <TabPane label="全部" name="-1"></TabPane>
        <TabPane label="待解除" name="0"></TabPane>
        <TabPane label="已解除" name="1"></TabPane>
      </Tabs>
      <Table
        border
        size="large"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <template slot-scope="{ row, index }" slot="action">
          <span class="pointer" @click="handleDeal(row)">详情</span>
        </template>
      </Table>
    </div>
    <div class="ft-box">
      <div class="ft-title aFlex">
        <Icon class="ft-title-mark" type="md-bookmark" />
        <span>预警信息</span>
      </div>
      <ul class="ft-form-wrapper">
        <li class="ft-form-item">
          <div class="ft-th">预警编号</div>
          <div class="ft-td">{{ earlyData.warningNumber }}</div>
        </li>
        <li class="ft-form-item">
          <div class="ft-th">预警对象</div>
          <div class="ft-td">{{ earlyData.cityName }}</div>
        </li>
        <li class="ft-form-item">
          <div class="ft-th">预警时间</div>
          <div class="ft-td">{{ earlyData.warningTime }}</div>
        </li>
        <li class="ft-form-item">
          <div class="ft-th">紧急程度</div>
          <div class="ft-td">{{ earlyData.urgencyString }}</div>
        </li>
        <li class="ft-form-item">
          <div class="ft-th">预警类型</div>
          <div class="ft-td">{{ earlyData.warningTypeString }}</div>
        </li>
        <li class="ft-form-item">
          <div class="ft-th">处理状态</div>
          <div class="ft-td">
            {{
              earlyData.handlingStatus
                ? "处理中"
                : earlyData.handlingStatus
                ? "已完成"
                : "已归档"
            }}
          </div>
        </li>
        <li class="ft-form-item" style="width: 100%">
          <div class="ft-th">预警项</div>
          <div class="ft-td">{{ earlyData.warningItemString }}</div>
        </li>
        <li class="ft-form-item" style="width: 100%">
          <div class="ft-th">预警消息</div>
          <div class="ft-td">{{ earlyData.noticeSmsContent }}</div>
        </li>
      </ul>
    </div>
    <div class="ft-box">
      <div class="ft-title aFlex">
        <Icon class="ft-title-mark" type="md-bookmark" />
        <span>短信通知</span>
      </div>
      <Table
        border
        size="large"
        :columns="messageColumns"
        :data="messageData"
        highlight-row
      >
      </Table>
      <Page
        class="page"
        :total="total"
        :page-size="size"
        :current="current"
        @on-change="changePage"
        @on-page-size-change="pageSizeChange"
        show-elevator
        show-sizer
        show-total
        transfer
      >
      </Page>
    </div>
    <!-- 动态码 弹窗-->
    <Modal v-model="ruleShow" :mask-closable="false" width="60">
      <p slot="header">
        <span>各项数据指标统计的规则说明</span>
      </p>
      <div class="notification" v-if="description.length > 0">
        1、更新率：是指区域内截止考勤日期系统中有考勤数据的项目数/系统在建状态项目数。平台支持查询前一天的更新率数据情况，前一天的更新率可在次日凌晨3点之后查询。如非当天上传的考勤数据，将不纳入统计。更新率{{
          description[0].thresholdValue
        }}视为达标。<br /><br />
        2、有考勤数据项目的平均上班工人数：是指区域内截止考勤日期的上班工人数/有考勤数据项目数。有考勤项目的平均上班工人数{{
          description[1].thresholdValue
        }}人视为达标。<br /><br />
        3、施工总承包单位项目经理的平均到岗率：是指所在区域内在建项目的施工总承包单位的有效项目经理出勤总人数/区域内在建项目的施工总承包单位的项目经理在岗总人数。(未设置该岗位的在建项目默认项目经理(注册建造师)在场人员总数为1)，项目经理到岗率{{
          description[2].thresholdValue
        }}视为达标。<br /><br />
        4、监理单位总监理工程师的平均到岗率：是指所在区域内在建项目的监理单位的有效总监理工程师出勤总人数/区域内在建项目的监理单位的总监理工程师在岗总人数。
        (未设置该岗位的在建项目默认总监理工程师(注册监理工程师)在场人员总数为1)，总监理工程师到岗率{{
          description[3].thresholdValue
        }}视为达标。<br /><br />
        5、项目经理和总监理工程师到岗率：是指
        [区域内在建项目的施工总承包单位的有效项目经理出勤总人数 +
        区域内在建项目的监理单位的有效总监理工程师出勤总人数] /
        [区域内在建项目的施工总承包单位的项目经理在场总人数 +
        区域内在建项目的监理单位的总监理工程师在场总人数]
        。(未设置该岗位的在建项目默认项目经理在场人员总数为1，未设置该岗位的在建项目默认总监理工程师在场人员总数为1)，项目经理和总监理工程师到岗率{{
          description[4].thresholdValue
        }}视为达标。<br /><br />
        6、停工率：是指区域内考勤日期内停工项目数量/非竣工项目数量的比例，停工率{{
          description[5].thresholdValue
        }}视为达标。<br /><br />
        7、未设置项目经理的项目数：
        是指区域内在建项目的施工总承包单位未设置项目经理岗位的管理人员项目数，未设置项目经理的项目数{{
          description[6].thresholdValue
        }}视为达标。<br /><br />
        8、未设置总监理工程师的项目数：是指区域内在建项目的监理单位未设置总监理工程师岗位的管理人员项目数，未设置总监理工程师的项目数{{
          description[7].thresholdValue
        }}视为达标。<br /><br />
        9、已设置但非注册建造师的项目数：是指区域内在建项目的施工总承包单位的项目经理人员不具备注册建造师的项目数，已设置但非注册建造师的项目数{{
          description[8].thresholdValue
        }}视为达标。<br /><br />
        10、已设置但非注册监理工程师的项目数：是指区域内在建项目的监理单位的总监理工程师人员不具备注册监理工程师的项目数，已设置但非注册监理工程师的项目数{{
          description[9].thresholdValue
        }}视为达标。<br /><br />
       <!-- 11、项目超期未审核：指省平台中显示项目申请对接市平台但主管单位超过3个工作日未审核的项目数，项目超期未审核数量{{
          description[10].thresholdValue
        }}视为达标。<br /><br />
        12、供应商超期未联调：指省平台中供应商申请对接市平台但超过5个工作日主管单位未反馈联调结果的申请单数量，供应商超期未联调数量{{
          description[11].thresholdValue
        }}视为达标。<br /><br />
        13、供应商超期未审核：指省平台中供应商申请对接市平台但超过3个工作日主管单位未审核的申请单数量，供应商超期未审核数量{{
          description[12].thresholdValue
        }}视为达标。<br /><br />-->
      </div>
      <div slot="footer" style="text-align: right">
        <Button type="primary" @click="ruleShow = false">关 闭</Button>
      </div>
    </Modal>
  </div>
</template>
<style scoped>
</style>
<script>
import { Page } from "view-design";

export default {
  components: { Page },
  data() {
    return {
      activeTabs: "-1",
      ruleShow: false,
      description: [],
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "预警类型",
          key: "warningTypeString",
          align: "left",
        },
        {
          title: "预警项",
          key: "warningItemString",
          minWidth: 120,
          tooltip: true,
          align: "left",
        },
        {
          title: "数据时间",
          key: "dataTimeString",
          align: "left",
        },
        {
          title: "达标标准",
          key: "thresholdValue",
          align: "left",
        },
        {
          title: "当前统计值",
          key: "warningValue",
          align: "left",
        },
        {
          title: "解除状态",
          key: "releaseStatusString",
          minWidth: 120,
          tooltip: true,
          align: "left",
        },
        {
          title: "问题清单",
          slot: "action",
          width: 100,
          align: "center",
        },
      ],
      tableData: [],
      earlyData: {},
      messageColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "通知对象",
          key: "noticeObjectName",
          width: 240,
          tooltip: true,
          align: "left",
        },
        {
          title: "手机号码",
          key: "phoneNumber",
          width: 180,
          align: "left",
        },
        {
          title: "通知时间",
          key: "sentOnDate",
          width: 180,
          align: "left",
        },
        {
          title: "发送状态",
          key: "sendSmsStatus",
          width: 100,
          align: "left",
        },
        {
          title: "通知内容",
          key: "noticeSmsContent",
          minWidth: 150,
          tooltip: true,
          align: "left",
        },
      ],
      messageData: [],
      total: 0,
      current: 1,
      size: 10,
        cityCode: '',
    };
  },
  computed: {},
  created() {
    this.earlyData = this.$route.params.earlyData;
    this.cityCode = this.$route.params.cityCode;
    if (this.earlyData != undefined) {
      window.sessionStorage.setItem(
        "earlyData",
        JSON.stringify(this.earlyData)
      );
    } else if (this.earlyData == undefined) {
      this.earlyData = JSON.parse(window.sessionStorage.getItem("earlyData"));
    }
    this.init();
  },
  mounted() {},
  watch: {},
  methods: {
    init() {
      this.getRules();
      this.getWarning();
      this.getPageData();
    },
    /*预警管理规则说明*/
    getRules() {
      let code =
        localStorage.getItem("tenantAreaCode").substring(0, 2) + "0000";
      this.axios({
        method: "POST",
        url: "/gd/warningManagement/warningInfoDetail/config",
        data: {
          areaCode: code,
        },
      }).then((response) => {
        if (response.data.success) {
          this.description = response.data.data;
        }
      });
    },
    /*预警项*/
    getWarning() {
      let data = {
        warningNumber: this.earlyData.warningNumber,
        releaseStatus: this.activeTabs,
          cityCode: this.cityCode,
      };
      this.axios({
        method: "POST",
        url: "/gd/warningManagement/warningInfoDetail/item",
        data,
      }).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
        }
      });
    },
    /*短信通知*/
    getPageData() {
      let data1 = {
        warningNumber: this.earlyData.warningNumber,
        current: this.current,
        size: this.size,
          cityCode: this.cityCode,
      };
      this.axios({
        method: "POST",
        url: "/gd/warningManagement/warningInfoDetail/sms",
        data: data1,
      }).then((response) => {
        if (response.data.success) {
          this.messageData = response.data.data.list;
          this.total = response.data.data.total;
        }
      });
    },
    // 选项切换
    tabsClikc(val) {
      this.activeTabs = val;
      this.getWarning();
    },
    /*详情跳转*/
    handleDeal(row) {
      let name = "";
      let data = {
        startDate: row.startDate,
        endDate: row.endDate,
        areaCode: this.earlyData.cityCode,
        status: ''
      }
      switch (row.warningType) {
        case 1:
          name = "monitoringProjectAnalysis";
          break;
        case 2:
          name = "theWorkAnalysis";
          break;
        case 3:
          name = "postWarning";
          break;
        case 4:
            if (row.warningItem == '11') {
                name = "projectSoftTestManage";
            } else {
                name = "softTestManage";
                data.areaCode = this.earlyData.cityCode.substring(0, 4) + "00"
                if (row.warningItem == '12') {
                    data.status = '4'
                } else if(row.warningItem == '13') {
                    data.status = '1'
                }
            }
          break;
        default:
          name = "";
      }
      let routeData = this.$router.resolve({
        name: name,
        query: data
      });
      window.open(routeData.href, '_blank')
    },
    /*新页数*/
    changePage(value) {
      this.current = value;
      this.getPageData();
    },
    /*每页的条数*/
    pageSizeChange(value) {
      this.size = value;
      this.current = 1;
      this.getPageData();
    },
  },
};
</script>
